import React, { useEffect, useState } from "react";
import LoginNavbar from "./LoginNavbar";
import ResetPage from "./ResetPage";
import { useHistory } from "react-router-dom";
import { useLocation } from "react-router-dom";

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

export default function Reset() {
  const query = useQuery();
  const history = useHistory();
  const token = query.get("token");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const itemStr = localStorage.getItem("userData");
    if (itemStr) {
      history.push("/");
    } else {
      setLoading(false);
    }
    document.title = "VisaPro | Reset Password";
  }, []);

  return (
    <div>
      {loading ? (
        <div
          style={{
            height: "100vh",
            width: "100%",
            backgroundColor: "transparent",
          }}
        ></div>
      ) : (
        <div>
          <LoginNavbar />
          <ResetPage token={token} />
        </div>
      )}
    </div>
  );
}
